import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import i18n from '@/api/i18n/i18n';

dayjs.extend(utc);

export const datePicker = (val) => dayjs(val).toDate();

export const dateRouter = (val, hour = 0, minute = 0, second = 0) =>
  dayjs(val).hour(hour).minute(minute).second(second).utc(true).format('YYYY-MM-DD HH:mm:ss');

export const date = (val) => dayjs(val).format('DD.MM.YYYY');

export const dateTime = (val) => dayjs(val).utc().format('DD.MM.YYYY HH:mm:ss');

/**
 * Форматирование длительности
 * @param {number} val количество секунд
 * @returns string
 */
export const duration = (val) => {
  if (val <= 0) {
    return val.toString(10);
  }

  const result = [];

  let restValue = val;

  const hours = restValue >= 3600 ? Math.floor(restValue / 3600) : 0;
  if (hours) {
    restValue -= hours * 3600;
    result.push(`${hours}${i18n.t('global.h')}`);
  }

  const minutes = restValue >= 60 ? Math.floor(restValue / 60) : 0;
  if (minutes) {
    restValue -= minutes * 60;
    result.push(`${minutes}${i18n.t('global.min')}`);
  }

  if (restValue) {
    result.push(`${restValue}с`);
  }

  return result.join(' ');
};
